const harlem = ({ imagePath, isMobile }) => (
  <div id="harlem-svg">
    <img src={`${imagePath}/harlem.svg`} alt="harlem" />
  </div>
);

export default harlem;
